import { Box, Text, TextField, Button, Flex, Grid, Card, Heading, Spinner, Badge, AlertDialog, IconButton, ScrollArea, Avatar, Separator, Dialog } from '@radix-ui/themes';
import { Cross2Icon, ChevronRightIcon, ChevronLeftIcon, ExclamationTriangleIcon, PlusCircledIcon, MinusCircledIcon, TrashIcon, CheckIcon, Pencil1Icon, DotFilledIcon, TargetIcon } from '@radix-ui/react-icons';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateAccountData } from '../../../redux/slices/accountSlice';
import api from '../../../api';
import { askAssistant, getCoursePlanDetails } from '../../../api/quiz';
import aiService from '../../../services/aiService';
import { createNewTopic } from '../../../api/courses';
import LoadingIndicator from '../../shared/LoadingIndicator';
import { v4 as uuidv4 } from 'uuid';
import Carousel from '../../carousel/Carousel';
import { saveQuiz } from '../../../api/quiz';
import { toast } from 'react-toastify';
import { Reorder } from "framer-motion";
import { courseService } from '../../../services/teacher/courseService';
import { teachingPlanService } from '../../../services/teacher/teachingPlanService';
import { updateTeacherCourses, updateTeacherTeachingPlans } from '../../../redux/slices/teacherAccountSlice';
import { useNavigate } from 'react-router-dom';
import EditQuestion from './EditQuestion';
import ScheduleView from './ScheduleView';
import TopicsPicker from './TopicsPicker';
import QuestionsGenerator from './QuestionsPicker';
import LessonNotesGenerator from './LessonNotesGenerator';
import LessonNotesView from './LessonNotesView';
import QuizCreator from './QuizCreator';
import Markdown from 'react-markdown';
import { DateTime } from 'luxon';


const ContentCreator = ({ draft = null }) => {
    const teacherAccount = useSelector(state => state.teacherAccount);
    const periods = useSelector(state => state.teacherAccount.periods).filter(period => period.status === 'active');
    const teachingPlans = useSelector(state => state.teacherAccount.teachingPlans);


    const dispatch = useDispatch();
    const [step, setStep] = useState(1);
    const [plan, setPlan] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [lessonNotes, setLessonNotes] = useState(null);

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [viewLessonNotes, setViewLessonNotes] = useState(null);
    const courses = useSelector(state => state.teacherAccount.courses);

    const navigate = useNavigate();

    const [content, setContent] = useState({
        course: null,
        type: '', // 'quiz', 'flashcard', 'assignment'
        topics: []
    });

    const [quiz, setQuiz] = useState({
        course: null,
        questions: [],
        topics: [],
        difficulty: 'medium',
        status: 'draft'
    });

    const resetContent = () => {
        setStep(1);
        setContent({
            course: null,
            type: '', // 'quiz', 'flashcard', 'assignment'
            topics: []
        })

    }

    const reloadCourse = async () => {
        const response = await getCoursePlanDetails(quiz.course.id);
        setPlan(response);
    }

    const getPlanDetails = async (teaching_plan_id) => {
        setIsLoading(true);
        try {
            const planDetails = await getCoursePlanDetails(teaching_plan_id);
            return planDetails;
        } catch (error) {
            console.error('Error getting course plan details:', error);
        } finally {
            setIsLoading(false);
        }
    }

    const handleCourseSelect = (course, type = 'quiz') => {
        if (type === 'preclass' && lessonNotes && lessonNotes[`notes${course.id}`] !== undefined) {
            console.log('lesson notes already exist for this course');
            console.log('lessonNotes', lessonNotes);
            setViewLessonNotes(`notes${course.id}`);
            return;
        } else {
            setContent({
                ...content,
                course: course,
                type
            })
            setStep(2);
        }
    };

    const handleTopicSelectCancel = () => {
        setContent({
            ...content,
            topics: [],
            lastLessonId: null
        });
        setStep(1);
    }

    useEffect(() => {
        const storedLessonNotes = sessionStorage.getItem('lessonNotes');
        if (storedLessonNotes) {
            const parsedNotes = JSON.parse(storedLessonNotes);
            const now = DateTime.now();

            // Filter out lesson notes older than 6 hours
            const activeNotes = Object.keys(parsedNotes).reduce((acc, key) => {
                const generatedAt = DateTime.fromISO(parsedNotes[key].generated_at);
                const timeDifference = now.diff(generatedAt, 'hours').hours;

                if (timeDifference < 6) {
                    acc[key] = parsedNotes[key];
                }
                return acc;
            }, {});

            // Save the updated lesson notes to session storage
            sessionStorage.setItem('lessonNotes', JSON.stringify(activeNotes));

            // Parse the content of each lesson note and update the state
            const lessonNotesArray = Object.keys(activeNotes).reduce((acc, key) => {
                acc[key] = {
                    content: JSON.parse(activeNotes[key].content),
                    generated_at: activeNotes[key].generated_at,
                };
                return acc;
            }, []);

            setLessonNotes(lessonNotesArray);
        }
    }, [content.type]);

    const handleSaveQuiz = async () => {
        console.log(quiz);
        try {
            const response = await saveQuiz({
                course_id: quiz.course.id,
                teaching_plan_id: quiz.course.active_teaching_plan.id,
                difficulty: quiz.difficulty,
                topics: quiz.topics,
                lesson_id: quiz.lesson_id,
                questions: quiz.questions
            });
            console.log('quiz created response>>>>>>>>>>', response);
            // dispatch(updateTeacherTeachingPlans(response.updated_teaching_plan));
            toast.success('Quiz created successfully');

            const updatedCourses = teacherAccount.courses.map(course => {
                if (course.id == quiz.course.id) {
                    return {
                        ...course,
                        active_teaching_plan: {
                            ...response.updated_teaching_plan
                        }
                    }
                }
                return course;
            });
            console.log('updated courses>>>>>>', updatedCourses);
            dispatch(updateTeacherCourses(updatedCourses));
            resetContent();
        } catch (error) {
            console.error('Error saving quiz:', error);
        }
    };

    const handleSaveQuestion = (question) => {
        console.log('question', question);

        setQuiz(prevQuiz => ({
            ...prevQuiz,
            questions: [...prevQuiz.questions, question]
        }));
        setShowCustomQuestion(false)
    }

    const handleDiscard = () => {
        if (window.confirm('Do you want to discard all changes?')) {
            console.log('discarding')
            resetQuiz();
        }
    }

    const cancelQuiz = () => {
        console.log('cancelling quiz')
    }


    const handleCompleteTopicSelection = ({ topics, lastLessonId }) => {
        const updateContent = {
            ...content,
            topics: topics,
            lastLessonId: lastLessonId
        };
        setContent(updateContent);
        setStep(3);
    }

    useEffect(() => {
        console.log('content', content);
    }, [content]);


    // const generateQuestions = async () => {
    //     setIsLoading(true);
    //     try {
    //         if (content.topics?.length === 0) {
    //             toast.error('Please select at least one topic');
    //             setIsLoading(false);
    //             return;
    //         }

    //         const aiResponse = await aiService.generateQuestions({
    //             course_id: content.course.id,
    //             topics: content.topics,
    //             level: content.course.level.label,
    //             subject: content.course.subject.name,
    //             difficulty: 'medium'
    //         });

    //         console.log('aiResponse', aiResponse);

    //         // Extract JSON from markdown code block
    //         const jsonMatch = aiResponse.match(/```json\n([\s\S]*?)\n```/);
    //         const jsonString = jsonMatch ? jsonMatch[1] : null;

    //         if (!jsonString) {
    //             throw new Error('Invalid AI response format');
    //         }

    //         const response = JSON.parse(jsonString);

    //         const questions = response.map(question => ({
    //             ...question,
    //             id: uuidv4()
    //         }));

    //         console.log('questions', questions);

    //         // setCurrentQuestionIndex(0);
    //         setQuestions(questions);
    //         setStep(3);
    //     } catch (error) {
    //         console.error('Error generating questions:', error);
    //         toast.error('Error generating questions. Please try again.');
    //     } finally {
    //         setIsLoading(false);
    //     }
    // }

    const handleSetupCourse = async (course) => {
        navigate(`/teacher/courses/${course.id}`);
    }

    const handleQuestionReorder = (oldIndex, newIndex) => {
        const newQuestions = reorder(questions, oldIndex, newIndex);
        setQuestions(newQuestions);
    }

    const handleRemoveQuestion = (question) => {
        setQuiz(prevQuiz => ({
            ...prevQuiz,
            questions: prevQuiz.questions.filter(q => q.id !== question.id)
        }));
    }

    const handleLessonNotesGenerated = (notes) => {
        setLessonNotes(prevNotes => ({
            ...prevNotes,
            [`notes${content.course.id}`]: {
                content: notes,
                generated_at: new Date().toISOString()
            }
        }));
        setViewLessonNotes(`notes${content.course.id}`);
        resetContent();
    }

    const handleQuizComplete = () => {
        const quizzes_count = content.course.active_teaching_plan.quizzes_count + 1;
        const updatedCourses = teacherAccount.courses.map(course => {
            if (course.id == content.course.id) {
                return {
                    ...course,
                    active_teaching_plan: {
                        ...course.active_teaching_plan, quizzes_count: quizzes_count
                    }
                }
            }
            return course;
        });
        dispatch(updateTeacherCourses(updatedCourses));
        toast.success('Quiz created successfully');
        resetContent();
        setStep(1);
    }

    const handleQuizCancel = () => {
        setStep(1);
        resetContent();
    }

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    }

    const renderPeriodPlans = (period) => {
        return (
            <>
                {courses.filter(course => course.active_teaching_plan != null).length > 0 && (
                    <Box width="100%" mt="2">
                        <Text size="1" color="gray">{period.title}</Text>
                        {courses.filter(course => plan.period_id === period.id).map(teachingPlan => (
                            <Card
                                key={teachingPlan.id}
                                onClick={() => handleCourseSelect(teachingPlan)}
                                style={{ cursor: 'pointer' }}
                                mt="2"
                            >
                                <Flex direction="row" justify="between" align="center">
                                    <Text size="1">{teachingPlan.course.level.label} | {teachingPlan.course.subject.name}</Text>
                                    <Badge size="1" color="gray">{teachingPlan.quizzes_count} quizzes</Badge>
                                </Flex>
                            </Card>
                        ))}
                    </Box>
                )}
            </>
        )
    }



    const renderPeriods = () => {
        if (periods?.length === 0) {
            return (
                <Flex direction="column" gap="4" align="center" justify="center" p="4">
                    <Text size="2" weight="bold">No active periods</Text>
                    <Text size="1" color="gray">You need to start a period to create a quiz</Text>
                    <Button size="1" onClick={() => navigate('/teacher/schedule')}>Go to Schedule</Button>
                </Flex>
            )
        }
        if (teachingPlans?.length === 0) {
            return (
                <Flex direction="column" gap="4" align="center" justify="center" p="4">
                    <Text size="2" weight="bold">No active teaching plans</Text>
                    <Text size="1" color="gray">You need to start a period with teaching plans to create a quiz</Text>
                    <Button size="1" onClick={() => navigate('/teacher/schedule')}>Go to Schedule</Button>
                </Flex>
            )
        }

        return (
            <Flex direction="column" gap="2">
                {periods.map(period => (
                    renderPeriodPlans(period)
                ))}
            </Flex>
        )
    }



    if (isLoading) {
        return <Box width="100%" height="100%" justify="center" align="center">
            <LoadingIndicator text="" />
        </Box>;
    }

    return (
        <Card style={{ minHeight: '300px', overflowY: 'auto' }}>
            {step === 1 && (
                <Flex direction="column" gap="3" width="100%">
                    <Text size="2">What did you teach today?</Text>
                    <ScheduleView courses={courses} onCourseSelect={handleCourseSelect} lessonNotes={lessonNotes} />
                </Flex>
            )}

            {/* Show the course plan */}
            {step === 2 && content.type === 'quiz' && (
                <QuizCreator topics={content.topics} course={content.course} onComplete={handleQuizComplete} onCancel={handleQuizCancel} />
            )}
            {step === 2 && content.type === 'preclass' && (
                <LessonNotesGenerator 
                availableNotes={(lessonNotes && lessonNotes[`notes${content.course.id}`]) ? lessonNotes[`notes${content.course.id}`] : null} 
                topics={content.topics} course={content.course} onComplete={handleLessonNotesGenerated} />
            )}
            
            {/* <TopicsPicker onComplete={handleCompleteTopicSelection} teachingPlan={content.course.active_teaching_plan} onCancel={handleTopicSelectCancel} selected={content.topics}/> */}
            

            {/* {step === 3 && content.type === 'quiz' && ( 
                    
                    // <Box mt="4">
                    //     <Flex direction="row" gap="4" width="100%" justify="between" align="center">
                    //         <Heading size="3" mb="2">Select Questions</Heading>
                    //         <Flex direction="row" gap="2">
                    //             <Button
                    //                 onClick={() => setStep(2)}
                    //                 size="2"
                    //                 variant="soft"
                    //                 color="gray"
                    //             >
                    //                 Cancel
                    //             </Button>
                    //             {quiz.questions?.length > 0 && (
                    //                 <Button
                    //                     onClick={() => handleQuestionSelectionComplete()}
                    //                     size="2"
                    //                 >
                    //                     Done
                    //                 </Button>
                    //             )}
                    //         </Flex>
                    //     </Flex>
                    //     <Text size="2" mb="4">Selected: {quiz.questions?.length || 0} questions</Text>


                    //     <Flex direction="column" gap="3">
                    //         <Carousel currentIndex={currentQuestionIndex} onIndexChange={setCurrentQuestionIndex}>
                    //             {questions.map((question) => (
                    //                 <Card
                    //                     key={question.id}
                    //                     onClick={() => toggleQuestionSelection(question)}
                    //                     style={{
                    //                         cursor: 'pointer',
                    //                         height: '400px',
                    //                         border: quiz.questions?.some(q => q.id === question.id)
                    //                             ? '2px solid var(--accent-9)'
                    //                             : '1px solid var(--gray-5)'
                    //                     }}
                    //                 >
                    //                      <Text>{question.id}</Text> 
                    //                     <Flex gap="2" wrap="wrap" mb="2">
                    //                         {question.core_competency?.map((competency, index) => (
                    //                             <Badge
                    //                                 key={index}
                    //                                 variant="solid"
                    //                                 radius="full"
                    //                                 color={
                    //                                     competency.toLowerCase().includes('concept') ? 'blue' :
                    //                                         competency.toLowerCase().includes('application') ? 'green' :
                    //                                             competency.toLowerCase().includes('vocabulary') ? 'orange' :
                    //                                                 'gray'
                    //                                 }
                    //                             >
                    //                                 {competency}
                    //                             </Badge>
                    //                         ))}
                    //                     </Flex>
                    //                     <Flex direction="column" gap="3">
                    //                         <Text size="2" weight="bold">{question.text}</Text>

                    //                         <Flex direction="column" gap="2" mb="4">
                    //                             {question.possible_answers.map((answer, index) => (
                    //                                 <Text
                    //                                     key={index}
                    //                                     size="2"
                    //                                     color={answer === question.correct_answer ? 'green' : 'gray'}
                    //                                 >
                    //                                     {index + 1}. {answer}
                    //                                 </Text>
                    //                             ))}
                    //                         </Flex>
                    //                         <Text size="2" weight="bold">Explanation</Text>
                    //                         <Text size="2" color="gray">{question.explanation}</Text>
                    //                     </Flex>
                    //                 </Card>
                    //             ))}
                    //         </Carousel>
                    //         <Flex direction="row" gap="2" justify="center" align="center">
                    //             <Button variant="soft" size="2" onClick={() => setCurrentQuestionIndex(currentQuestionIndex - 1)} disabled={currentQuestionIndex === 0}>
                    //                 <ChevronLeftIcon />
                    //             </Button>
                    //             <Button variant="solid" size="2" onClick={() => handleSelectQuestionByIndex(currentQuestionIndex)}>
                    //                 Select
                    //             </Button>
                    //             <Button variant="soft" size="2" onClick={() => setCurrentQuestionIndex(currentQuestionIndex + 1)} disabled={currentQuestionIndex === questions.length - 1}>
                    //                 <ChevronRightIcon />
                    //             </Button>
                    //         </Flex>
                    //     </Flex>
                    // </Box>
                )}

                {/* {step === 3 && content.type === 'preclass' && (
                    
                )} 

                {/* {step === 4 && (
                    <>
                        {showCustomQuestion ? (
                            <EditQuestion onSave={handleSaveQuestion} onCancel={() => setShowCustomQuestion(false)}
                                topics={plan.lessons[browsing.lesson]?.topics}
                            />
                        ) : (
                            <Flex direction="column" gap="3">
                                <Flex direction="column" gap="2" mb="4">
                                    <Flex justify="between" align="center">
                                        <Text size="2">{quiz.course?.level?.label} {quiz.course?.subject?.name}</Text>
                                        <Badge size="1">{quiz.questions.length} questions</Badge>
                                    </Flex>
                                    <Text size="4" color="gray" weight="bold">{quiz?.topic?.name}</Text>
                                </Flex>
                                <Reorder.Group
                                    axis="y"
                                    values={quiz.questions}
                                    onReorder={(newOrder) => setQuiz(prev => ({ ...prev, questions: newOrder }))}
                                >
                                    {quiz.questions.map((question) => (
                                        <Reorder.Item
                                            key={question.id}
                                            value={question}
                                            style={{ cursor: 'grab' }}
                                        >
                                            <Card mb="2">
                                                <Flex direction="column" gap="2">
                                                    <Text
                                                        size="2"
                                                        style={{
                                                            overflow: 'hidden',
                                                            display: '-webkit-box',
                                                            WebkitLineClamp: 2,
                                                            WebkitBoxOrient: 'vertical'
                                                        }}
                                                    >
                                                        {question.text}
                                                    </Text>
                                                    <Flex gap="2" wrap="wrap" align="center">
                                                        {question.core_competency?.map((competency, index) => (
                                                            <Badge
                                                                key={index}
                                                                variant="solid"
                                                                radius="full"
                                                                color={
                                                                    competency.toLowerCase().includes('concept') ? 'blue' :
                                                                        competency.toLowerCase().includes('application') ? 'green' :
                                                                            competency.toLowerCase().includes('vocabulary') ? 'orange' :
                                                                                'gray'
                                                                }
                                                            >
                                                                {competency}
                                                            </Badge>
                                                        ))}
                                                        <IconButton variant="soft" size="2" style={{ marginLeft: 'auto' }} onClick={() => setShowCustomQuestion(true)}>
                                                            <Pencil1Icon />
                                                        </IconButton>
                                                        <IconButton variant="soft" color="red" size="2" onClick={() => handleRemoveQuestion(question)}>
                                                            <TrashIcon />
                                                        </IconButton>
                                                    </Flex>
                                                </Flex>
                                            </Card>
                                        </Reorder.Item>
                                    ))}
                                </Reorder.Group>
                                <Flex gap="2" style={{ marginTop: '16px' }}>
                                    <Button
                                        size="2"
                                        variant="soft"
                                        onClick={() => setStep(3)}
                                    >
                                        Edit Questions
                                    </Button>
                                    <Button
                                        size="2"
                                        variant="soft"
                                        onClick={() => setShowCustomQuestion(true)}
                                    >
                                        Add Custom Question
                                    </Button>
                                    <Button
                                        size="2"
                                        variant="solid"
                                        onClick={handleSaveQuiz}
                                    >
                                        Create Quiz
                                    </Button>
                                </Flex>
                            </Flex>
                        )}
                    </>
                )} */}
            {viewLessonNotes && <Dialog.Root open={viewLessonNotes} onOpenChange={(bool) => bool ? null : setViewLessonNotes(null)}>
                <Dialog.Content>
                    <LessonNotesView notes={lessonNotes[viewLessonNotes].content} />
                    {/* {viewLessonNotes && (
                        <Box>
                            {lessonNotes[viewLessonNotes].content.style && (<Box mb="4" className="teaching-style" style={{ background: 'var(--green-10)', color: 'var(--green-1)' }}><Markdown>{lessonNotes[viewLessonNotes].content.style.content}</Markdown></Box>)}
                            {lessonNotes[viewLessonNotes].content.notes && (<Box mb="4" className="notes"><Markdown>{lessonNotes[viewLessonNotes].content.notes.content}</Markdown></Box>)}
                            {lessonNotes[viewLessonNotes].content.other && (<Box mb="4" className="other"><Markdown>{lessonNotes[viewLessonNotes].content.other.content}</Markdown></Box>)}
                        </Box>
                    )} */}
                </Dialog.Content>
            </Dialog.Root>}
        </Card>
    );
};

export default ContentCreator;
